import React from "react";
import { PropTypes } from "prop-types";

import "css/admin/utils/circular-spinner.scss";

function CircularSpinner({ children, classnames, loading }) {
  return (
    <>
      {loading ? (
        <div className={`circular-spinner ${classnames}`}>
          <svg className="circular-loader" viewBox="25 25 50 50">
            <circle className="loader-path" cx="50" cy="50" r="20" />
          </svg>
        </div>
      ) : (
        <>{children}</>
      )}
    </>
  );
}

CircularSpinner.propTypes = {
  children: PropTypes.node,
  classnames: PropTypes.string,
  loading: PropTypes.bool.isRequired,
};

export default CircularSpinner;
